export const treeAppealGuideUrl = '/docs/מדריך להגשת ערר על כריתת עץ.pdf';
